// extracted by mini-css-extract-plugin
module.exports = {"delete":"UnavailabilityDetail_delete__19zS8"};